/*
DynamicSearch.js
 */
var DynamicSearch = function(){
    this.$element = $('.search-input input');
    this.query = '';
    this.category = '';
    this.ajaxObject = null;
    this.isLoad = false;
    this.callback;
    this.inLoadingCallback;
}

DynamicSearch.prototype = {
    init: function() {
        var _this = this;

        _this.$element.on('keyup', function() { var element = this; _this.search(element); });
        _this.$element.parents('form').on('submit', function() { return false; });

        $('.search-selector-tab .tab a').on('click', function() { 
            $(this).parent().siblings().each(function() {
                $(this).removeClass('is-tab-active');
            });

            $(this).parent().addClass('is-tab-active');
            _this.setCategory($(this).data('category'));
            _this.search(_this.$element); 
            return false;
        });

        $('.search-select-body').on('change', function() { 
            $('.input-container-view').text($(this).children('option:selected').text());
            _this.setCategory($(this).val());
            _this.search(_this.$element); 
        });
    },

    setCategory: function(category) {
        this.category = category;
        this.query = '';
    },

    setCallback: function(callback) {
        this.callback = callback;
    },

    setInLoadingCallback: function(callback) {
        this.inLoadingCallback = callback;
    },

    search: function(element) {
        var _this = this;
        var $element = $(element);
        var query = $element.val();

        if (query == '') {
            $('.search-loading').addClass('loading-off');
            $('.card').addClass('fadeout').on('animationend', function() {
                $('.cards').html('');

                if (typeof _this.inLoadingCallback == 'function') {
                    _this.inLoadingCallback();
                }
            });

            window.history.pushState('', '', $element.parents('form').attr('action') + '?s=');
            return;
        }

        if (query == this.query) {
            return;
        }

        if (this.isLoad) {
            this.ajaxObject.abort();
        }

        $('.search-loading').removeClass('loading-off');
        $('.card').addClass('fadeout').on('animationend', function() {
            $('.cards').html('');

            if (typeof _this.inLoadingCallback == 'function') {
                _this.inLoadingCallback();
            }
        });

        var key = $element.attr('name');
        var action = $element.parents('form').attr('action');
        var param = {'append': true};
        param[key] = query;

        if (this.category != '') {
            param['category_name'] = this.category;
        }

        this.isLoad = true;
        this.query = query;
        this.ajaxObject = $.ajax({
            url: action,
            data: param,
            timeout: 5000
        }).done(function(data) {
            if (data.replace(/\s/g, '') == '' || $(data).find('.js-infinite-scroll').attr('href') == '') {
                $('.search-loading').addClass('loading-off');
            }

            $('.cards').html(data);

            var url = action + '?' + key + '=' + query;

            if (_this.category != '') {
                url += '&category_name=' + _this.category;
            }

            window.history.pushState('', '', url);

            if (typeof _this.callback == 'function') {
                _this.callback();
            }

            _this.isLoad = false;
        });
    }
}

module.exports = DynamicSearch;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/DynamicSearch.js
 **/